import React, { useEffect, useState } from "react";

import { sortArray } from "../utils";
import RadioButton from "../RadioButton";

import cx from "classnames";
import styles from "./styles.module.scss";

const RadioButtonGroup = ({
  name,
  question,
  options,
  defaultOption,
  onChange,
  className,
  buttonsContainerCSS,
  required,
  updateUserData,
}) => {
  const [selectedValue, setSelectedValue] = useState(null);

  useEffect(() => {
    if (!selectedValue) {
      setSelectedValue(defaultOption);
    }
  }, [defaultOption]);

  const onValueChanged = async (newValue) => {
    let reqData = {
      nextEntry: { id: newValue, value: true },
      type: "select",
    };

    if (selectedValue || selectedValue === 0) {
      reqData = { ...reqData, prevEntry: { id: selectedValue } };
    }

    setSelectedValue(newValue);
    onChange && onChange(newValue);
    updateUserData(reqData);
  };

  const sortedOptions = sortArray(options, "order", "asc");

  const containerCSS = cx(styles.RadioButtonGroup, className);

  return (
    <div className={containerCSS}>
      <div className={styles.RadioButtonGroup__question}>
        <span>{question}</span>
        {required && (
          <span className={styles.RadioButtonGroup__requiredStar}>*</span>
        )}
      </div>
      <div className={buttonsContainerCSS}>
        {sortedOptions.map((option) => {
          const isChecked = selectedValue === option.id;
          return (
            <RadioButton
              key={`${name}-${option.id}`}
              id={`${name}-${option.id}`}
              name={name}
              className={styles.RadioButtonGroup__singleOption}
              label={option.label}
              value={option.id}
              checked={isChecked}
              onChange={onValueChanged}
            />
          );
        })}
      </div>
    </div>
  );
};

export default RadioButtonGroup;
